module.exports = __webpack_public_path__ + "media/images/icon-map-fb96c3d2d578c122b8ac3b896e1a0552.svg";